import { Apple, ShieldAlert, ShieldCheck, Lock, Clock, Fingerprint, Users } from "lucide-react";

// Fiche membre (Admin › Utilisateurs) : tranche d'âge Apple Declared Age Range (iOS 26+).
// Données privées (permission « Utilisateurs »), jamais sur le profil public — Apple ne transmet AUCUNE date de naissance.
const BANDS = {
  under13: { label: "Moins de 13 ans", bg: "#FEE2E2", fg: "#991B1B" },
  "13-15": { label: "13 – 15 ans", bg: "#FEF3C7", fg: "#92400E" },
  "16-17": { label: "16 – 17 ans", bg: "#E0F2FE", fg: "#075985" },
  "18+": { label: "18 ans et plus", bg: "#D1FAE5", fg: "#065F46" },
};
const METHODS = {
  selfDeclared: "Auto-déclarée (compte Apple du membre)",
  guardianDeclared: "Déclarée par un parent ou tuteur (Partage familial)",
  governmentIDChecked: "Vérifiée par Apple avec une pièce d'identité",
  paymentMethodChecked: "Vérifiée par Apple via un moyen de paiement",
};
const CONTROLS = { communicationLimits: "Limites de communication (contrôle parental)" };

export const bandLabel = (band) => BANDS[band]?.label || band || "—";
export const methodLabel = (d) => (d ? METHODS[d] || d : "Non précisée par Apple");
const when = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso).slice(0, 16) : d.toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" });
};

const Row = ({ icon: Icon, label, value, testId, tone }) => (
  <div className="flex items-start justify-between gap-3 py-1.5 border-b last:border-b-0" style={{ borderColor: "var(--yalola-border)" }} data-testid={testId}>
    <div className="flex items-center gap-1.5 text-xs shrink-0" style={{ color: "var(--yalola-text-muted)" }}><Icon size={13} /> {label}</div>
    <div className="text-xs font-semibold text-right" style={tone ? { color: tone } : undefined}>{value}</div>
  </div>
);

export const UserAgeAssuranceCard = ({ aa }) => {
  const band = aa?.band ? BANDS[aa.band] : null;
  const under = aa?.band === "under13";
  return (
    <div className="rounded-xl p-3" style={{ border: "1px solid var(--yalola-border)" }} data-testid="user-age-card" data-band={aa?.band || "none"}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="text-sm font-semibold font-display flex items-center gap-1.5"><Apple size={14} /> Tranche d'âge Apple <span className="text-[11px] font-normal" style={{ color: "var(--yalola-text-muted)" }}>(iOS 26+)</span></div>
        <span className="chip text-[10px] flex items-center gap-1" style={{ background: "#F2F4F7", color: "#475467" }} data-testid="user-age-private"><Lock size={10} /> Privé — équipe uniquement</span>
      </div>
      {!aa?.band ? (
        <p className="mt-2 text-xs" style={{ color: "var(--yalola-text-muted)" }} data-testid="user-age-none">
          Non transmise par l'appareil (compte web / Android, ou iOS antérieur à 26). La règle Yalola (date de naissance saisie) s'applique seule.
        </p>
      ) : (
        <div className="mt-2">
          <Row icon={under ? ShieldAlert : ShieldCheck} label="Tranche" testId="user-age-band" tone={band?.fg}
               value={<span className="chip text-[11px]" style={{ background: band?.bg || "#F2F4F7", color: band?.fg || "#475467" }}>{bandLabel(aa.band)}</span>} />
          <Row icon={Fingerprint} label="Méthode (Apple)" value={methodLabel(aa.declaration)} testId="user-age-method" />
          <Row icon={Clock} label="Dernier contrôle" value={when(aa.checked_at)} testId="user-age-checked" />
          {(aa.parental_controls || []).length > 0 && (
            <Row icon={Users} label="Contrôle parental" testId="user-age-parental"
                 value={aa.parental_controls.map((c) => CONTROLS[c] || c).join(", ")} />
          )}
        </div>
      )}
      <p className="mt-2 text-[11px]" style={{ color: "var(--yalola-text-muted)" }} data-testid="user-age-note">
        Apple ne transmet qu'une tranche, jamais la date de naissance ; rien n'est affiché sur le profil public.
      </p>
    </div>
  );
};
